<template>
  <div id="dod12" class="dod dodSingle">

    <header class="dodSingle_header">
      <router-link class="dodSingle_header_logo" v-bind:to="{ name: 'home' }" v-touchfeedback>
        ← tmiame
      </router-link>
      <div class="dodSingle_header_title">
        #day12 - Scroll Parallax Animation
      </div>
    </header>

    <div class="Prallax">
      <div style="position: fixed; top: 0px; width: 1px; height: 1px; z-index: 1;"></div>
      <div class="Prallax_container">

        <div class="Prallax_inner">

          <div class="Block" id="P01">
            <div class="Block_box"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P01", "start": "0vh", "end": "-100vh", "y": [-100, 0], "scale": [2, 1], "breakpoint": "all"}
              ]'>
              <div class="Block_box_image"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P01", "start": "0vh", "end": "-100vh", "scale": [1.1, 1], "breakpoint": "L"}
              ]'>
                <img v-bind:src="image01" />
              </div>
            </div>
            <div class="Block_box"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P01", "start": "0vh", "end": "-100vh", "y": [100, -0], "breakpoint": "L"}
              ]'>
              <div class="Block_box_image"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P01", "start": "0vh", "end": "-100vh", "scale": [1, 1.1], "breakpoint": "L"}
              ]'>
                <img v-bind:src="image01" />
              </div>
            </div>
            <div class="Block_text"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P01", "start": "0vh", "end": "-100vh", "y": [-50, 50], "breakpoint": "L"}
              ]'>
              <span class="Block_text_title">RAITO<br>RACER</span>
              <span class="Block_text_description">DISCOVER NOW</span>
            </div>
          </div>

          <div class="Block" id="P10">
            <div class="Block_box is-02"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P10", "start": "100%", "end": "-100%", "y": [-100, 100], "breakpoint": "all", "includeStart": "70px"}
              ]'>
              <div class="Block_box_image"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P10", "start": "100vh", "end": "-100vh", "scale": [1.1, 1], "breakpoint": "all", "includeStart": "70px"}
              ]'>
                <img v-bind:src="image01" />
              </div>
            </div>
            <div class="Block_box is-02"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P10", "start": "100vh", "end": "0", "y": [-100, 0], "breakpoint": "all", "includeStart": "70px", "includeEnd": "0"}
              ]'>
              <div class="Block_box_image"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P10", "start": "100vh", "end": "-100vh", "scale": [1, 1.1], "breakpoint": "all", "includeStart": "70px"}
              ]'>
                <img v-bind:src="image01" />
              </div>
            </div>
            <div class="Block_text"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P10", "start": "100vh", "end": "-100vh", "y": [-50, 50], "breakpoint": "all", "includeStart": "70px"}
              ]'>
              <span class="Block_text_title">RAITO<br>RACER</span>
              <span class="Block_text_description">DISCOVER NOW</span>
            </div>
          </div>

          <div class="Block" id="P02">
            <div class="Block_box"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P02", "start": "100vh", "end": "-100vh", "y": [30, -30], "breakpoint": "all"}
              ]'>
              <div class="Block_box_image"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P02", "start": "100vh", "end": "-100vh", "scale": [1.2, 1], "breakpoint": "all"}
              ]'>
                <img v-bind:src="image03" />
              </div>
            </div>
            <div class="Block_box"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P02", "start": "100vh", "end": "-100vh", "y": [-30, 30], "breakpoint": "all"}
              ]'>
              <div class="Block_box_image"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P02", "start": "100vh", "end": "-100vh", "scale": [1.2, 1], "breakpoint": "all"}
              ]'>
                <img v-bind:src="image04" />
              </div>
            </div>
            <div class="Block_text"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P02", "start": "100vh", "end": "-100vh", "y": [-50, 50], "breakpoint": "all"}
              ]'>
              <span class="Block_text_title">RAITO<br>RACER</span>
              <span class="Block_text_description">DISCOVER NOW</span>
            </div>
          </div>

          <div class="Block" id="P03">
            <div class="Block_box"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P03", "start": "100vh", "end": "-100vh", "y": [-30, 30], "breakpoint": "all"}
              ]'>
              <div class="Block_box_image"
              data-parallax
              data-parallax-tweens='[
                {"parent": false, "start": "100vh", "end": "-100vh", "scale": [1, 1.15], "breakpoint": "all"}
              ]'>
                <img v-bind:src="image05" />
              </div>
            </div>
            <div class="Block_box"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P03", "start": "100vh", "end": "-100vh", "y": [30, -30], "breakpoint": "all"}
              ]'>
              <div class="Block_box_image"
              data-parallax
              data-parallax-tweens='[
                {"parent": false, "start": "100vh", "end": "-100vh", "scale": [1, 1.15], "breakpoint": "all"}
              ]'>
                <img v-bind:src="image06" />
              </div>
            </div>
            <div class="Block_text"
              data-parallax
              data-parallax-tweens='[
                {"parent": "P03", "start": "100vh", "end": "-100vh", "y": [-50, 50], "breakpoint": "all"}
              ]'>
              <span class="Block_text_title">RAITO<br>RACER</span>
              <span class="Block_text_description">DISCOVER NOW</span>
            </div>
          </div>

          <div class="Item dod12_section dod12_section--type2" id="item02">
            <div class="Item_headline">
              <div class="Item_headline_title u-mb-base">
                Parallax Scroll
              </div>
              <div class="Item_headline_subtitle"
                data-parallax
                data-parallax-tweens='[
                  {"parent": "item02", "start": "100vh", "end": "0vh", "y": [0, 40], "breakpoint": "all"}
                ]'>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              </div>
            </div>
            <div class="Item_image">
              <img v-bind:src="image1"
                data-parallax
                data-parallax-tweens='[
                  {"parent": false, "start": "100vh", "end": "-100vh", "y": [-40, 40], "breakpoint": "all"},
                  {"parent": false, "start": "100vh", "end": "0vh", "scale": [1.1, 1.2], "breakpoint": "all"}
                ]'
              />
            </div>
          </div>

          <div class="dod12_section dod12_section--type4" id="section4">
            <div class="type4_sticky" id="section4_2">
              <div class="type4_sticky_type"
                data-parallax
                data-parallax-tweens='[
                  {"parent": "section4", "start": "100vh", "end": "-100vh", "y": ["-100%","100%"], "breakpoint": "all"}
                ]'
                data-text="Parallax"
              >
              </div>
              <div class="type4_sticky_type"
                data-text="Scroll"
              ></div>
              <div class="type4_sticky_type"
                data-parallax
                data-parallax-tweens='[
                  {"parent": "section4", "start": "100vh", "end": "-100vh", "y": [1000, -1000], "breakpoint": "all"}
                ]'
                data-text="Animation"
              ></div>
            </div>
          </div>

          <div class="dod12_section dod12_section--type3" id="section3">
            <div class="type3_bg"
              v-bind:style="`background-image: url(${type3Bg})`"
              data-parallax
              data-parallax-tweens='[
                {"parent": false, "start": "100vh", "end": "-100vh", "y": [-10, 10], "breakpoint": "all"},
                {"parent": false, "start": "100vh", "end": "0vh", "scale": [1.1, 1.5], "breakpoint": "all"}
              ]'
            />
            <div class="type3_bgMaskTop"
              data-parallax
              data-parallax-tweens='[
                {"parent": false, "start": "50vh", "end": "0", "opacity": [1, 0], "breakpoint": "all"}
              ]'
            />
          </div>

          <div class="Item" id="item03">
            <div class="Item_headline">
              <div class="Item_headline_title u-mb-base">
                無制限の<br>
                オンライン ストレージで、<br>
                思い出を好きなだけ保存。
              </div>
              <div class="Item_headline_subtitle"
                data-parallax
                data-parallax-tweens='[
                  {"parent": "item03", "start": "100vh", "end": "0vh", "y": [0, 40], "breakpoint": "all"},
                  {"parent": false, "start": "100vh", "end": "0vh", "opacity": [1, 0], "breakpoint": "all"}
                ]'>Google フォトでは、元の画質の写真や 4K 動画をすべて保存できる無制限のオンライン ストレージを無料でご利用いただけます2。Google フォトでは、元の画質の写真や 4K 動画をすべて保存できる無制限のオンライン ストレージを無料でご利用いただけます2。
              </div>
            </div>
            <div class="Item_image">
              <img v-bind:src="image1"
                data-parallax
                data-parallax-tweens='[
                  {"parent": false, "start": "100vh", "end": "-100vh", "y": [-40, 40], "breakpoint": "all"},
                  {"parent": false, "start": "100vh", "end": "0vh", "scale": [1.1, 1.2], "breakpoint": "all"},
                  {"parent": false, "start": "100vh", "end": "50vh", "opacity": [1, 0], "breakpoint": "all"}
                ]'
              />
            </div>
          </div>

          <div class="Item" id="item04">
            <div class="Item_headline">
              <div class="Item_headline_title u-mb-base">
                無制限の<br>
                オンライン ストレージで、<br>
                思い出を好きなだけ保存。
              </div>
              <div class="Item_headline_subtitle"
                data-parallax
                data-parallax-tweens='[
                  {"parent": "item04", "start": "100vh", "end": "0vh", "y": [0, 40], "breakpoint": "all"},
                  {"parent": false, "start": "100vh", "end": "0vh", "opacity": [1, 0], "breakpoint": "all"}
                ]'>Google フォトでは、元の画質の写真や 4K 動画をすべて保存できる無制限のオンライン ストレージを無料でご利用いただけます2。Google フォトでは、元の画質の写真や 4K 動画をすべて保存できる無制限のオンライン ストレージを無料でご利用いただけます2。
              </div>
            </div>
            <div class="Item_image">
              <img v-bind:src="image1"
                data-parallax
                data-parallax-tweens='[
                  {"parent": false, "start": "100vh", "end": "-100vh", "y": [-40, 40], "breakpoint": "all"},
                  {"parent": false, "start": "100vh", "end": "0vh", "scale": [1.1, 1.2], "breakpoint": "all"},
                  {"parent": false, "start": "100vh", "end": "0vh", "opacity": [1, 0], "breakpoint": "all"}
                ]'
              />
            </div>
          </div>

        </div><!-- /Prallax_inner -->
      </div><!-- /Prallax_container -->
    </div><!-- /Prallax -->
  </div><!-- /dod -->
</template>

<script>
import { Parallax } from '@/modules/day12-parallax-scroll'

export default {
  name: 'Day12Page',

  data: () => ({
    parallax: false,
    image01: require('@/assets/images/dod_day12_image_01.jpg'),
    image02: require('@/assets/images/dod_day12_image_02.jpg'),
    image03: require('@/assets/images/dod_day12_image_03.jpg'),
    image04: require('@/assets/images/dod_day12_image_04.jpg'),
    image05: require('@/assets/images/dod_day12_image_05.jpg'),
    image06: require('@/assets/images/dod_day12_image_06.jpg'),
    image1: require('@/assets/images/dod_day12_image1.png'),
    type3Bg: require('@/assets/images/dod/image_0008.jpg')
  }),

  methods: {
    init() {
      this.parallax = new Parallax({
        targets: [...document.querySelectorAll('#dod12 [data-parallax]')]
      })
    }
  },

  beforeDestroy() {
    if (this.parallax) {
      this.parallax.destroy()
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0)
      this.init()
    })
  },

  created() {
    // window.addEventListener('load', this.init, false)
  }
}
</script>

<style scoped lang="scss">
@mixin container {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding-left: 50px;
  padding-right: 50px;
  @include FR_MQ_ONLY(QT) {
    padding-left: 3vw;
    padding-right: 3vw;
  }
  @include FR_MQ_ONLY(QS) {
    padding-left: 3vw;
    padding-right: 3vw;
  }
}

[data-parallax] {
  transform: translateZ(0);
  transform-origin: top center;
  will-change: auto;
  &.is-element-in-view {
    will-change: transform, opacity, scroll-position;
    // visibility: visible;
  }
  &.is-element-in-out {
    // visibility: hidden;
  }
  &.is-element-show-important {
    // visibility: visible;
  }
}

.Prallax_container {
  position: relative;
  width: 100%;
  padding-bottom: 100vh;
  img {
    width: 100%;
  }
}

.Prallax_inner {
  padding-bottom: 50vh;
  @include FR_MQ_ONLY(QT) {
    padding-bottom: 100vw;
  }
  @include FR_MQ_ONLY(QS) {
    padding-bottom: 100vw;
  }
}

.dod12_section {
  position: relative;
}

/**************************************************
 * Parallax > Item
 **************************************************/
.Item {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.dod12_section--type2 {
  // padding-top: 20vmin;
  // padding-bottom: 20vmin;
  background-color: #111111;
  color: #ffffff;
}

/**************************************************
 * Section > Type3
 **************************************************/
.dod12_section--type3 {
  overflow: hidden;
}

.type3_bg {
  @include FR_BG;
  height: 100vh;
}

.type3_bgMaskTop {
  @include FR_FULLSIZE;
  background-image: linear-gradient(rgba(#000000, 1), rgba(#000000, 0));
}

/**************************************************
 * Section > Type4
 **************************************************/
.dod12_section--type4 {
  position: relative;
  min-height: 300vh;
  background-color: blue;
  color: #000000;
}

.type4_sticky {
  @include FR_FLEX_LAYOUT(flex-start, flex-start);
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(#00ff00, 0.5);
  overflow: hidden;
}

.type4_sticky_type {
  @include WEBFONT(normal, 400);
  background-color: red;
  font-size: 20vw;
  font-weight: 800;
  line-height: 1;
  width: (100% / 3);
  text-align: center;
  height: 100vh;
  &:before {
    content: attr(data-text);
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    transform: rotate(90deg) translateY(calc(-100% + 0.5em)) translateX(-50%);
    transform-origin: 0 0;
    line-height: 1;
    background-color: yellow;
  }
  &:nth-child(2) {
    left: 50%;
  }
  &:nth-child(3) {
    left: 75%;
  }
}

.Item_headline {
  @include WEBFONT(normal, 400);
  padding-top: 20vmin;
  padding-bottom: 10vmin;
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
  // padding-top: 3rem;
  text-align: center;
  position: relative;
  @include FR_MQ_ONLY(QS) {
    font-size: 0.7rem;
  }
  &_subtitle {
    @include FONTSIZE(M, S);
    font-weight: 500;
    margin-left: auto;
    margin-right: auto;
    max-width: 46em;
  }
  &_title {
    font-size: 5vw;
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: -0.015em;
    @include FR_MQ_ONLY(QS) {
      font-size: 15vw;
    }
  }
}

.Item_image {
  position: relative;
}

/**************************************************
 * Parallax > Block
 **************************************************/
.Block {
  @include FR_FLEX_LAYOUT(space-between, stretch);
  position: relative;
  padding-top: 100px;
  padding-bottom: 100px;
  padding-right: 8vw;
  box-shadow: inset 0 0 0 1px #00ff00;
  min-height: 300px;
  &:nth-child(even) {
    padding-left: 8vw;
    padding-right: 0;
  }
}

.Block_box {
  width: 48%;
  background-color: #dddddd;
  overflow: hidden;
}

.Block_box_image {
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.Block_text {
  position: absolute;
  bottom: 20%;
  right: 2%;
  .Block:nth-child(even) & {
    left: 2%;
    right: auto;
  }
}

.Block_text_title {
  @include FONTSIZE(L, L);
  display: block;
  line-height: 1.4;
  margin-bottom: 0.5em;
}

.Block_text_description {
  @include FONTSIZE(M, S);
  display: block;
  white-space: nowrap;
}
</style>
